"use strict";function delete$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.delete$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.cspace.delete";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.21"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.21"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"4.5.21"},_a)),exports.delete$=delete$,exports.default=delete$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/cspace/delete.js
// module id = 939
// module chunks = 106